import React from 'react';
import PropTypes from 'prop-types';
import {Box, Paper} from '@tenancy.nz/design-system';

function FormPaper({children}) {
  return (
    <Paper>
      <Box sx={{padding: {xs: '24px', md: '32px'}}}>{children}</Box>
    </Paper>
  );
}

FormPaper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormPaper;
